import { UserManager } from "oidc-client";
import { AnalyticsOidcConfiguration } from "../../oidc-configuration";

export interface EmbeddedConsole {
  EmbedUrl: string;
}

export enum GetEmbeddedConsoleErrors {
  Unauthorized = "You are not authorized to view the Insights Portal. Redirecting back to login page.",
  Generic = "An error has occured trying to fetch the Insights Portal. Refresh the page or contact IT.",
}

interface IEmbeddedConsoleService {
  getConsole: (
    cognitoIdToken: string,
    idToken: string,
    dashboardId?: string
  ) => Promise<EmbeddedConsole | Error>;
}

export const EmbeddedConsoleService: IEmbeddedConsoleService = {
  getConsole: async (cognitoIdToken, idToken, dashboardId) => {
    const dashboardParams = window.sessionStorage.getItem("dashboard");
    window.sessionStorage.removeItem("dashboard");

    let url = `${process.env.REACT_APP_API_ROOT}/analytics-console/console?idToken=${idToken}`;
    if (dashboardId) {
      url += `&dashboard=${dashboardId}`;
    } else if (dashboardParams) {
      url += `&dashboard=${dashboardParams}`;
    }
    const consoleResponse = fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${cognitoIdToken}`,
      },
    })
      .then((x) => {
        switch (x.status) {
          case 200:
            return x.json();
          case 401:
            setTimeout(async () => {
              const m = new UserManager(AnalyticsOidcConfiguration);

              await m.signoutRedirect();
            }, 5000);
            return Error(GetEmbeddedConsoleErrors.Unauthorized);
          default:
            return Error(GetEmbeddedConsoleErrors.Generic);
        }
      })
      .then((x) => x as EmbeddedConsole);

    return consoleResponse;
  },
};
